import React, { useEffect }  from "react";
import InputField from "components/fields/InputField";
import Button from "components/button";
import { connect } from "react-redux";
import { doUserRegistration } from "../../redux/user/userState";
import { Alert, Card, Form } from 'antd';
import { Lock,  Mail, User, UserPlus } from "lucide-react";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import { setFormFieldsError } from "utils/index";

const Register = ({ registerUser, loading, error }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    setFormFieldsError(form, error);
  }, [error, form]);

  const onSubmit = (formData) => {
    try { 
			registerUser(formData);
    } catch (error) {
        console.error('Registration failed:', error);
    }
  };

  return (
    <div className="relative max-w-[300px] md:max-w-[500px] items-center justify-center  md:mx-0 md:px-0 mt-8" >

      <Card 
        className="w-full dark:border-gray-600 bg-card text-card-foreground flex flex-col gap-6 rounded-xl shadow-2xl border-2 border-purple-100">

          <div className="flex flex-col items-center justify-center mb-6 space-y-2">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-2">
              <UserPlus className="w-8 h-8 text-white"/>
            </div>
            <h1 className="text-xl font-medium">
              Create Account
            </h1>
            <p className="text-base text-slate-500">
              Join Hyvid and start your journey
            </p>

          </div>
          {/* {error &&
          <div className="min-h-[18px] my-3">
              <Alert className="p-3 text-red-700" message={error} type="error" showIcon /> 
          </div>  
          } */}
          
          <Form className="form"
            form={form} 
            layout="vertical"
            onFinish={onSubmit}
          >   
            <div className="h-full w-full max-w-full flex-col items-center lg:pl-0 ">
            
              <div className="flex grid grid-cols-2 gap-2"> 
                <FormItem className="font-medium"
                  name="first_name"
                  label="First Name"
                  rules={[requiredField()]}
                  extra="mb-3"
				        >
                  <InputField
                    variant="auth"
                    prefix={<User className="w-4 h-4 text-gray-600 transition-colors"/>}
                    placeholder="John"
                    id="first_name"
                    type="text"
                  />
                </FormItem>

                <FormItem className="font-medium"
                  name="last_name"
                  label="Last Name"
                  rules={[requiredField()]}
                  extra="mb-3"
				        >
                  <InputField
                    variant="auth"
                    prefix={<User className="w-4 h-4 text-gray-600 transition-colors"/>}
                    placeholder="Doe"
                    id="last_name"
                    type="text"
                  />
                </FormItem>
                
              </div>

              <FormItem className="font-medium"
                name="email"
                label="Email Address"
                rules={[requiredField()]}
                extra="mb-3"
              >
                <InputField
                  variant="auth"
                  prefix={<Mail className="w-4 h-4 text-gray-600 transition-colors"/>}
                  placeholder="yourname@hyvidone.com"
                  id="email"
                  type="text"
                />
              </FormItem>
              <FormItem className="font-medium"
                name="password"
                label="Password"
                rules={[requiredField()]}
                extra="mb-3"
              >
                <InputField
                  variant="auth"
                  prefix={<Lock className="w-4 h-4 text-gray-600 transition-colors"/>}
                  placeholder="At least 8 characters"
                  id="password"
                  type="password"
                  visibilityToggle={false}
                />
              </FormItem>
              <FormItem className="font-medium"
                name="password_confirmation"
                label="Confirm Password"
                rules={[requiredField()]}
                extra="mb-3"
              >
                <InputField
                  variant="auth"
                  prefix={<Lock className="w-4 h-4 text-gray-600 transition-colors"/>}
                  placeholder="At least 8 characters"
                  id="password_confirmation"
                  type="password"
                  visibilityToggle={false}
                />
              </FormItem>

              <div className="text-center mt-8">
                <Button type="submit" 
                  extra={`btn-gradient-emerald h-9 w-full ${loading && 'disabled'}`} 
                  disabled={loading}
                >
                  Create Account
                </Button>
              </div>
              
            </div>

          </Form>

      </Card>
    </div>
  );
}

const mapStateToProps = (state) => ({
  error: state.user.userDetails?.error,
  loading: state.user.userDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  registerUser: (formData) => dispatch(doUserRegistration(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
